export default __webpack_public_path__ + "static/1-a3cd37c9afb5de31d0fb8f0a81faa8b2.png";